import {
  ExternalNetworkEntityKindSchema,
  type AssetGraphResponseDto,
  type ExternalNetworkEntityKind,
} from '@terra/shared-contracts-external-network';
import type { GraphWebAppCluster } from './buildFlowApplicationNodes';

export type RelatedRouteAssetKind = ExternalNetworkEntityKind | 'APPLICATION';

export type RelatedRouteAsset = {
  id: string;
  kind: RelatedRouteAssetKind;
  label: string;
  signalsCount: number;
  applicationId?: string;
};

export function isRelatedRouteEntityKind(
  kind: string,
): kind is ExternalNetworkEntityKind {
  return ExternalNetworkEntityKindSchema.safeParse(kind).success;
}

export function listRelatedRouteAssets({
  graph,
  selectedNodeId,
  webAppClusters = [],
}: {
  graph: AssetGraphResponseDto;
  selectedNodeId: string;
  webAppClusters?: GraphWebAppCluster[];
}): RelatedRouteAsset[] {
  const relatedAssets = graph.nodes.flatMap((node) => {
    if (node.id === selectedNodeId || node.nodeType === 'cluster') {
      return [];
    }

    const parsedKind = ExternalNetworkEntityKindSchema.safeParse(node.kind);

    if (!parsedKind.success) {
      return [];
    }

    return [
      {
        id: node.id,
        kind: parsedKind.data,
        label: node.label,
        signalsCount: node.properties.signalsCount ?? 0,
      },
    ];
  });

  const relatedApplications = webAppClusters.flatMap((cluster) => {
    if (!cluster.application || cluster.application.id === selectedNodeId) {
      return [];
    }

    return [
      {
        id: cluster.application.id,
        kind: 'APPLICATION' as const,
        label: cluster.application.name,
        signalsCount: 0,
        applicationId: cluster.application.id,
      },
    ];
  });

  return [...relatedAssets, ...relatedApplications];
}
